const { ValidationError } = require('../errors');
const { REQUIRED_PROFILE_FIELDS } = require('../entities/user');

const validateRating = (rating, name) => {
  if (typeof rating !== 'number' || !Number.isInteger(rating) || rating < 1 || rating > 5) {
    throw new ValidationError(`${name} must be an integer between 1 and 5.`);
  }
};

// Mirrors functions/index.js submitReview's inline validation.
const validateReviewInput = ({ bookingId, culinaryRating, serviceRating, cleanlinessRating, reviewText }) => {
  if (!bookingId || typeof bookingId !== 'string') {
    throw new ValidationError('bookingId is required.');
  }

  validateRating(culinaryRating, 'culinaryRating');
  validateRating(serviceRating, 'serviceRating');
  validateRating(cleanlinessRating, 'cleanlinessRating');

  if (reviewText !== undefined && reviewText !== null) {
    if (typeof reviewText !== 'string' || reviewText.length > 1000) {
      throw new ValidationError('reviewText must be a string of 1000 characters or less.');
    }
  }
};

// Mirrors src/Auth/UpdateProfile.js's required-field set.
const validateProfileInput = (profile) => {
  const fieldErrors = REQUIRED_PROFILE_FIELDS.filter(
    (field) => !profile[field] || `${profile[field]}`.trim() === ''
  );

  if (fieldErrors.length > 0) {
    throw new ValidationError(`Missing required profile fields: ${fieldErrors.join(', ')}`, fieldErrors);
  }
};

// Mirrors src/services/bookingService.js's bookMeal guard clauses.
const validateBookingInput = ({ mealId, guestId, hostId }) => {
  if (!mealId || typeof mealId !== 'string') {
    throw new ValidationError('mealId is required.');
  }
  if (!guestId || typeof guestId !== 'string') {
    throw new ValidationError('guestId is required.');
  }
  if (!hostId || typeof hostId !== 'string') {
    throw new ValidationError('hostId is required.');
  }
  if (guestId === hostId) {
    throw new ValidationError('You cannot book your own meal.');
  }
};

const MAX_GUESTS_LIMIT = 8;
const ZIP_REGEX = /^\d{5}(-\d{4})?$/;

const nonEmpty = (value) => typeof value === 'string' && value.trim().length > 0;

const validateMaxGuests = (maxGuests) => {
  const guests = Number(maxGuests);
  return Number.isInteger(guests) && guests >= 1 && guests <= MAX_GUESTS_LIMIT;
};

// Mirrors src/Auth/host/createListing.js's validateForm.
const validateMealInput = ({
  title, description, cuisineType, menu, dateTime, maxGuests,
  street, city, state, zipCode, neighborhood, bookingCutoff,
}) => {
  const fieldErrors = [];
  if (!nonEmpty(title) || title.length > 100) fieldErrors.push('title');
  if (!nonEmpty(description) || description.length > 500) fieldErrors.push('description');
  if (!cuisineType) fieldErrors.push('cuisineType');
  if (menu && menu.length > 500) fieldErrors.push('menu');
  if (!dateTime || Number.isNaN(new Date(dateTime).getTime()) || new Date(dateTime) <= new Date()) {
    fieldErrors.push('dateTime');
  }
  if (!validateMaxGuests(maxGuests)) fieldErrors.push('maxGuests');
  if (!nonEmpty(street)) fieldErrors.push('street');
  if (!nonEmpty(city)) fieldErrors.push('city');
  if (!nonEmpty(state)) fieldErrors.push('state');
  if (!zipCode || !ZIP_REGEX.test(zipCode.trim())) fieldErrors.push('zipCode');
  if (!neighborhood) fieldErrors.push('neighborhood');
  if (!bookingCutoff) fieldErrors.push('bookingCutoff');

  if (fieldErrors.length > 0) {
    throw new ValidationError(`Invalid meal fields: ${fieldErrors.join(', ')}`, fieldErrors);
  }
};

// Mirrors src/Auth/host/editListing.js's validateForm (editable field subset only).
const validateMealEditInput = ({ title, description, menu, maxGuests, bookingCutoff }) => {
  const fieldErrors = [];
  if (!nonEmpty(title) || title.length > 100) fieldErrors.push('title');
  if (!nonEmpty(description) || description.length > 500) fieldErrors.push('description');
  if (menu && menu.length > 500) fieldErrors.push('menu');
  if (!validateMaxGuests(maxGuests)) fieldErrors.push('maxGuests');
  if (!bookingCutoff) fieldErrors.push('bookingCutoff');

  if (fieldErrors.length > 0) {
    throw new ValidationError(`Invalid meal fields: ${fieldErrors.join(', ')}`, fieldErrors);
  }
};

module.exports = {
  validateRating,
  validateReviewInput,
  validateProfileInput,
  validateBookingInput,
  validateMealInput,
  validateMealEditInput,
};
